import { render, staticRenderFns } from "./whatOffer.vue?vue&type=template&id=ed66fb46&scoped=true"
import script from "./whatOffer.vue?vue&type=script&lang=js"
export * from "./whatOffer.vue?vue&type=script&lang=js"
import style0 from "./whatOffer.vue?vue&type=style&index=0&id=ed66fb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed66fb46",
  null
  
)

export default component.exports